import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";
import { defaultGradientColor } from "@shortsworks/ui";

interface ColorsSchemaProps {}
// default value가 문자열로 넘어가는 현상
// 모양에 대한 타입 설정이 필요
// push에서 다른 방식으로 가능한 지 체크
export const ColorsSchema = (shape: "story" | "shorts"): FormFieldSchema[] => {
  const schema: FormFieldSchema[] = [];

  if(shape === "shorts") {
    schema.push(
        {
          type: FormFieldType.Switch,
          id: "shortsVisibleBorder",
          label: "쇼츠 모양 테두리 컬러 사용",
          description: "쇼츠 모양의 테두리 컬러를 표시합니다.",
          defaultValue: true,
        }
    )
  }

  schema.push(
      {
        type: FormFieldType.Color,
        id: shape === "story" ? "storyBorderColor" : "shortsBorderColor",
        // 모양에 따른 케이스 분리 필요
        label:
            shape === "story" ? "스토리 모양 테두리 설정" : "쇼츠 모양 테두리 설정",
        description: "위젯의 테두리 색상을 설정할 수 있습니다.",
        defaultValue: defaultGradientColor(),
        appearance: {
          border: false,
        },
      }
  )

  return schema;
}
